import React, { memo, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import Modal from 'utils/packages/Modal';
import { useAppDispatch } from 'store/hooks';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import { OnboardingFlow } from 'utils/types/navigation';
import { clearOnboardingState } from 'features/invest/actions';
import { clearPotsOnboardingState } from 'features/pots/actions';
// Shown on onboarding steps rendered inline in the Invest and Save tabs,
// where there is no screen to go back to.
const LeaveOnboardingButton = ({ flow }) => {
    const dispatch = useAppDispatch();
    const leave = useCallback(() => {
        if (flow === OnboardingFlow.Pots) {
            // Answers shared with invest onboarding are kept; only pots progress is cleared.
            dispatch(clearPotsOnboardingState());
            dispatch(setDeviceSettingsKey('hasTriedSettingsUpPots', false));
        }
        else {
            dispatch(clearOnboardingState());
            dispatch(setDeviceSettingsKey('hasTriedSettingsUpInvest', false));
        }
    }, [dispatch, flow]);
    const onPress = useCallback(() => {
        Modal.showConfirmation({
            title: 'Leave and start over?',
            subtitle: 'Your answers won’t be saved, so you’ll need to start again next time',
            confirmButtonTitle: 'Go back', // secondary
            cancelButtonTitle: 'Leave', // primary
            onPressCancel: leave,
        });
    }, [leave]);
    return (<View style={staticStyles.container}>
      <NavigationCloseButton testID="leave-onboarding-button" onPress={onPress}/>
    </View>);
};
export default memo(LeaveOnboardingButton);
const staticStyles = StyleSheet.create({
    container: {
        paddingLeft: rem(16),
        marginBottom: rem(6),
        alignItems: 'flex-start',
    },
});
